export class HomedKeys {
  welcome = 'frontPage.greeting';
}
